<header>
  <dx-toolbar class="header-toolbar">
    <dxi-item
      *ngIf="menuToggleEnabled"
      location="before"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }"
    >
    </dxi-item>
    <dxi-item
      style="display: flex !important; align-items: center !important;"
      location="before"
      cssClass="header-title"
      [onClick]="gotoMain"
    >
      <img src="assets/logo-dabnet.png" alt="" width="80"  height="25"/>
      <img class="bld-logo" src="assets/logo-medium.png" alt="" width="30" height="30"/>
    </dxi-item>
    <dxi-item *ngIf="isTestScreen"
      location="before"
    >
      <b class="test-text">&nbsp;Test Ortamı&nbsp;</b>
    </dxi-item>

<ng-container *ngIf="!(kullaniciBilgi$ | async)?.canUseDaBApp">
    <dxi-item location="center">
      <span class="izin-text">
        {{(kullaniciBilgi$ | async)?.message}}
      </span>
    </dxi-item>
  </ng-container>



  

    <dxi-item location="after" style="display: flex; gap: 5px">
      <dx-button icon="refresh" (onClick)="onRefresh()" [stylingMode]="'contained'" 
      [type]="'danger'" [text]="'Yeni Sürüm Bulundu(Yenile)'" [visible]="hasNewVersion"> </dx-button>
      <!-- Analiz Merkezi: yalnız menüsünde olan kullanıcıya (admin ya da kutucuk yetkisi) -->
      <dx-button *ngIf="analizMerkeziYetkili$ | async" icon="chart" [hint]="'Analiz Merkezi'" (onClick)="onAnalizMerkezi()"> </dx-button>
      <!-- Kabuk canlandırma (02.10.2026): eski hâli
      <dx-button icon="user" (onClick)="onPersonelInfo()"> </dx-button>
      <dx-button icon="event" (onClick)="onSchedular()"> </dx-button>
      <dx-button icon="tableproperties" (onClick)="onTask()"> </dx-button>
      -->
      <dx-button icon="user" [hint]="'Personel Bilgilerim'" (onClick)="onPersonelInfo()"> </dx-button>
      <dx-button icon="event" [hint]="'Takvim'" (onClick)="onSchedular()"> </dx-button>
      <dx-button icon="tableproperties" [hint]="'Görevler'" (onClick)="onTask()"> </dx-button>
      <span class="ayrac"></span>
    </dxi-item>
    <!-- Kompakt düzen anahtarı (16.10.2026, deneme): açıkken sol menü daraltılır (ikon şeridi / açılır menü),
         açık sekmeler sağda sabit panelde. Geri almak: bu dxi-item silinir (bkz. CalismaDuzeniService).
         dxi-item koşulsuz (koşullu dxi-item toolbar'ı baştan çizdirir). -->
    <dxi-item location="after" locateInMenu="never">
      <ng-container *dxTemplate>
        <!-- 18.10.2026: anahtar ile Görünüm menüsü (▾) tek kapsülde; eskiden yalnız anahtar vardı -->
        <span class="kompakt-kapsul">
        <button
          type="button"
          class="kompakt-anahtar"
          role="switch"
          [class.acik]="kompakt$ | async"
          [attr.aria-checked]="!!(kompakt$ | async)"
          [title]="(kompakt$ | async)
            ? 'Kompakt düzen açık — kapatınca menü açılır, sekmeler üstte görünür'
            : 'Kompakt düzen: menü daralır, açık sekmeler sağda sabit panelde listelenir'"
          (click)="kompaktDegistir()"
        >
          <i class="fa-solid fa-table-columns"></i>
          <span class="kompakt-ad">Kompakt</span>
          <span class="kompakt-ray"><span class="kompakt-top"></span></span>
        </button>
        <dk-gorunum-menusu></dk-gorunum-menusu>
        </span>
      </ng-container>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
      <ng-container *dxTemplate>
        <dk-theme-switcher></dk-theme-switcher>
      </ng-container>
    </dxi-item>
<!-- Kabuk canlandırma (02.10.2026): eski hâli — zil ve iş sayaçları ayrı öğelerdi
  <dxi-item location="after">
  <div  (click)="togglePopover()"  *dxTemplate class="notification-wrapper">
    <dx-button
      #bellBtn
      icon="bell"
      [hint]="'Bildirimler'"
      [type]="'normal'"
      stylingMode="text"
    ></dx-button>
    <div *ngIf="bildirimCount >= 1" class="badge">{{bildirimCount}}</div>
  </div>
    </dxi-item>
    <dxi-item location="after">
  <ng-template dxTemplate>
    <div *ngFor="let item of toolbarItems" (click)="openFormClick(item)" class="notification-wrapper">
      <dx-button
        class="position-relative"
        [icon]="item.icon"
        [hint]="item.dynamicText"
        [type]="item.type || 'normal'"
        [stylingMode]="'contained'"
      >
      </dx-button>
      <div *ngIf="item.sayac >= 1" class="badge">{{ item.sayac }}</div>
    </div>
  </ng-template>
</dxi-item>
-->
    <!-- EBYS iş sayaçları tek kapsülde: ikon kendi renginde, sayı köşede rozet (0 ise sönük, 99 üstü "99+");
         kırmızı rozet yalnız zilde (gerçek bildirim). -->
    <dxi-item location="after">
  <ng-template dxTemplate>
    <div class="kapsul">
      <button
        *ngFor="let item of toolbarItems"
        type="button"
        class="sayac"
        [class.sifir]="!(+item.sayac >= 1)"
        [style.--r]="item.renk"
        [title]="item.dynamicText + ' — ' + (item.sayac || 0)"
        (click)="openFormClick(item)"
      >
        <i class="dx-icon dx-icon-{{ item.icon }}"></i>
        <span *ngIf="+item.sayac >= 1" class="sayac-rozet">{{ +item.sayac > 99 ? '99+' : item.sayac }}</span>
      </button>
    </div>
  </ng-template>
</dxi-item>
    <!-- Zil: EBYS sayaçları ile kullanıcı adı arasında (dtokgoz 02.10) -->
    <dxi-item location="after">
  <div (click)="togglePopover()" *dxTemplate class="notification-wrapper zil">
    <dx-button
      #bellBtn
      icon="bell"
      [hint]="'Bildirimler'"
      [type]="'normal'"
      stylingMode="text"
    ></dx-button>
    <div *ngIf="bildirimCount >= 1" class="badge">{{ bildirimCount > 99 ? '99+' : bildirimCount }}</div>
  </div>
    </dxi-item>

    <dxi-item location="after" locateInMenu="never">
      <ng-container *dxTemplate>
        <dk-profile-selector></dk-profile-selector>
      </ng-container>
    </dxi-item>
    
  </dx-toolbar>
</header>

 <div class="pop-table-container">
    <ng-container>
      <dk-gen-bildirim
      ></dk-gen-bildirim>
    </ng-container>
</div>